import React, { useRef, useEffect } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Container, Row } from 'reactstrap'
import { useSelector } from 'react-redux'
import { signOut } from 'firebase/auth'

import './header.css'
import useAuth from '../../custom-hooks/useAuth'
import { auth } from '../../firebase.config'
import brandMark from '../../assets/brand/gadget-groove-mark.png'

const navLinks = [
  { path: 'home', display: 'Home' },
  { path: 'shop', display: 'Shop' },
  { path: 'cart', display: 'Cart' },
  { path: 'about', display: 'About' },
]

const Header = () => {
  const headerRef = useRef(null)
  const menuRef = useRef(null)
  const navigate = useNavigate()
  const totalQuantity = useSelector((state) => state.cart.totalQuantity)
  const { currentUser } = useAuth()

  useEffect(() => {
    const handleScroll = () => {
      headerRef.current?.classList.toggle('sticky__header', window.scrollY > 80)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const menuToggle = () => menuRef.current?.classList.toggle('active__menu')

  const logout = () => {
    signOut(auth)
      .then(() => {
        toast.success('Logged out')
        navigate('/home')
      })
      .catch((err) => toast.error(err.message))
  }

  return (
    <>
      <div className='announcement'>Free nationwide delivery on orders over Rs. 50,000 <span>•</span> 14-day easy returns</div>
      <header className='header' ref={headerRef}>
        <Container>
          <Row>
            <div className='nav__wrapper'>
              <NavLink to='/home' className='logo' aria-label='Gadget Groove home'>
                <span className='logo__mark'><img src={brandMark} alt='' width='36' height='36' /></span>
                <span className='logo__word'>Gadget<span>Groove</span></span>
              </NavLink>

              <nav className='navigation' ref={menuRef} onClick={menuToggle} aria-label='Main navigation'>
                <ul className='menu'>
                  {navLinks.map((item) => (
                    <li className='nav__item' key={item.path}>
                      <NavLink to={item.path} className={({ isActive }) => isActive ? 'nav__active' : ''}>
                        {item.display}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </nav>

              <div className='nav__icons'>
                <NavLink to='/shop' className='icon__button search__shortcut' aria-label='Search products'>
                  <i className='ri-search-line'></i>
                </NavLink>
                <button className='icon__button cart__icon' onClick={() => navigate('/cart')} aria-label={`Cart with ${totalQuantity} items`}>
                  <i className='ri-shopping-bag-line'></i>
                  <span className='badge'>{totalQuantity}</span>
                </button>
                <button className='icon__button' onClick={() => navigate('/login')} aria-label={currentUser ? currentUser.email : 'Sign in'} title={currentUser?.email}>
                  <i className='ri-user-3-line'></i>
                </button>
                {currentUser && (
                  <button className='icon__button logout__button' onClick={logout} aria-label='Sign out'>
                    <i className='ri-logout-box-line'></i>
                  </button>
                )}
                <div className='mobile__menu'>
                  <button className='icon__button' onClick={menuToggle} aria-label='Open menu'>
                    <i className='ri-menu-3-line'></i>
                  </button>
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </header>
    </>
  )
}

export default Header
